export default __webpack_public_path__ + "static/media/PSignUp.015767e3.png";